/**
 * Who may sign in to docs.veraclins.dev.
 *
 * This is the entire authorisation model: there are no roles and no user
 * records, so membership of a company mail domain is what grants access.
 * Pure and dependency-free on purpose — it is the piece most worth unit
 * testing, and it must behave identically on the login form and on redemption.
 */
const ALLOWED_EMAIL_DOMAINS = ['veraclins.com', 'veraclins.dev'] as const;

export function normalizeEmail(email: string): string {
  return email.trim().toLowerCase();
}

export function isAllowedEmail(email: string): boolean {
  const normalized = normalizeEmail(email);

  // Split on the LAST '@': local parts may legally contain one when quoted,
  // and taking the first would hand an attacker `evil@x.com@veraclins.dev`.
  const at = normalized.lastIndexOf('@');
  if (at <= 0 || at === normalized.length - 1) {
    return false;
  }

  const domain = normalized.slice(at + 1);
  return (ALLOWED_EMAIL_DOMAINS as readonly string[]).includes(domain);
}

export const allowedDomainsLabel = ALLOWED_EMAIL_DOMAINS.map(
  (domain) => `@${domain}`,
).join(' or ');
